import 'styles/quotecheckbutton.css';

const QuoteCheckButton = (
    {
        variable,
        setVariable,
        label,
        onChange,
    }
) => {
    
  const handleCheckboxChange = () => {
    setVariable(!variable);
    onChange(!variable);
  };

  return (
    <div
        className='QuoteCheckButton'
    >
        <div>
            {label}
        </div>
        <div
            className='toggle-switch'
        >
            <input
                type="checkbox"
                id={label}
                checked={variable}
                onChange={handleCheckboxChange}
                className="toggle-switch-checkbox"
            />
            <label className="toggle-switch-label" htmlFor={label}>
                <span className="toggle-switch-inner" />
                <span className="toggle-switch-switch" />
            </label>
        </div>
    </div>
  );
};

export default QuoteCheckButton;